import { Box, Divider, FlexBox, Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { memo } from 'react';

import { CopilotSelectionList } from './components';

type CopilotDropdownRootProps = {
  readonly onSelectionChange: (actionName: string) => void;
};

/**
 * Represents the root component of the Copilot dropdown that will render the
 * list of actual actions.
 */
export const CopilotDropdownRoot = memo(function CopilotDropdownRoot({
  onSelectionChange,
}: CopilotDropdownRootProps) {
  return (
    <FlexBox flexDirection="column" style={{ width: 400 }}>
      <Box padding="200 300">
        <Text.Heading variant="heading-3" color={colors.purple['600']}>
          AI features powered by Dixa
        </Text.Heading>
      </Box>

      <Divider />

      <CopilotSelectionList onChange={onSelectionChange} />
    </FlexBox>
  );
});
